import React from 'react'
import { Loader } from '../Loader/Loader'
import { Select, Space } from 'antd';
import { List, Row, Col, Typography } from "antd";
import {
    ArrowUpOutlined,
    ArrowDownOutlined,
} from "@ant-design/icons";
import btc from '../Assets/btc.png'
import eur from '../Assets/eur.png'

const { Text } = Typography;

const data = [
    {
        time: "17:42",
        date: "20 Sep",
        icon: btc, // your image path
        pair: "BTC/USD (OTC)",
        type: "Blitz",
        result: -100,
        investment: 100,
    },
    {
        time: "15:19",
        date: "20 Sep",
        icon: eur, // your image path
        pair: "EUR/USD (OTC)",
        type: "1 Binary",
        result: 1720,
        investment: 2000,
    },
    {
        time: "17:40",
        date: "19 Sep",
        icon: btc, // your image path
        pair: "TRON/USD (OTC)",
        type: "2 Binary",
        result: -280,
        investment: 4000,
    },
    {
        time: "17:10",
        date: "19 Sep",
        icon: eur, // your image path
        pair: "TRON/USD (OTC)",
        type: "1 Binary",
        result: 1720,
        investment: 2000,
    },
    {
        time: "17:42",
        date: "20 Sep",
        icon: btc, // your image path
        pair: "BTC/USD (OTC)",
        type: "Blitz",
        result: -100,
        investment: 100,
    },
    {
        time: "15:19",
        date: "20 Sep",
        icon: eur, // your image path
        pair: "EUR/USD (OTC)",
        type: "1 Binary",
        result: 1720,
        investment: 2000,
    },
    {
        time: "17:40",
        date: "19 Sep",
        icon: btc, // your image path
        pair: "TRON/USD (OTC)",
        type: "2 Binary",
        result: -280,
        investment: 4000,
    },
    {
        time: "17:10",
        date: "19 Sep",
        icon: eur, // your image path
        pair: "TRON/USD (OTC)",
        type: "1 Binary",
        result: 1720,
        investment: 2000,
    },
    {
        time: "17:42",
        date: "20 Sep",
        icon: btc, // your image path
        pair: "BTC/USD (OTC)",
        type: "Blitz",
        result: -100,
        investment: 100,
    },
    {
        time: "15:19",
        date: "20 Sep",
        icon: eur, // your image path
        pair: "EUR/USD (OTC)",
        type: "1 Binary",
        result: 1720,
        investment: 2000,
    },
    {
        time: "17:40",
        date: "19 Sep",
        icon: btc, // your image path
        pair: "TRON/USD (OTC)",
        type: "2 Binary",
        result: -280,
        investment: 4000,
    },
    {
        time: "17:10",
        date: "19 Sep",
        icon: eur, // your image path
        pair: "TRON/USD (OTC)",
        type: "1 Binary",
        result: 1720,
        investment: 2000,
    },
    {
        time: "17:42",
        date: "20 Sep",
        icon: btc, // your image path
        pair: "BTC/USD (OTC)",
        type: "Blitz",
        result: -100,
        investment: 100,
    },
    {
        time: "15:19",
        date: "20 Sep",
        icon: eur, // your image path
        pair: "EUR/USD (OTC)",
        type: "1 Binary",
        result: 1720,
        investment: 2000,
    },
    {
        time: "17:40",
        date: "19 Sep",
        icon: btc, // your image path
        pair: "TRON/USD (OTC)",
        type: "2 Binary",
        result: -280,
        investment: 4000,
    },
    {
        time: "17:10",
        date: "19 Sep",
        icon: eur, // your image path
        pair: "Suriya (OTC)",
        type: "1 Binary",
        result: 1720,
        investment: 2000,
    },
];
const TradeHitorySide = ({ loader, setCollapsed }) => {



    return (
        <>
            {loader ?
                <Loader /> :
                <>
                    <div className='display-5 p-20 trad-pos'>
                        <div className='side-title'>
                            Trading History
                        </div>
                        <div className='cursor' onClick={() => setCollapsed(true)} id='cs'>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z" fill="#82858E" stroke="#82858E" stroke-width="1.5294" />
                            </svg>
                        </div>
                    </div>
                    <div className='mt-5 p-10'
                        id='cs'

                    >
                        <Select
                            defaultValue="All Positions"
                            style={{ width: "100%" }}
                            // onChange={handleChange}
                            suffixIcon={<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.66667 10L0 0H14L6.66667 10Z" fill="white" />
                            </svg>
                            }

                            className='history-select'
                            options={[
                                { value: 'AllPositions', label: 'All Positions' },
                                { value: 'forex', label: 'Forex' },
                                { value: 'crypto', label: 'Crypto' },
                                { value: 'disabled', label: 'Disabled', disabled: true },
                            ]}
                            id='cs'

                        />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {/* ...your header and filters above... */}
                        <div style={{ flex: 1, overflowY: 'auto' }}>
                            <List
                                itemLayout="horizontal"
                                dataSource={data}
                                renderItem={(item) => (
                                    <List.Item
                                        style={{
                                            background: "#1e293b",
                                            // borderRadius: 8,
                                            marginBottom: 6,
                                            padding: "5px 12px",
                                            borderBottom: "1px solid #3B404F",
                                            display: 'flex'
                                        }}
                                    >
                                        <Row style={{ width: "100%" }} align="middle">
                                            {/* Left - Time and Date */}
                                            <Col span={4}>
                                                <Text style={{ color: "#fff" }} className='time-h'>{item.time}</Text>
                                                <br />
                                                <Text type="secondary" className='date-h '>{item.date}</Text>
                                            </Col>

                                            {/* Middle - Icon + Pair + Type */}
                                            <Col span={15} style={{ display: "flex", alignItems: "flex-start", justifyContent: "flex-start", paddingLeft: "12px" }}>
                                                <div>
                                                    <img
                                                        src={item.icon}
                                                        alt={item.pair}
                                                        style={{ width: 28, height: "auto", marginRight: 8 }}
                                                    />
                                                    <div style={{ marginTop: "-5px" }}>
                                                        <Text type="secondary" className='type-h'>{item.type}</Text>

                                                    </div>

                                                </div>

                                                <div>
                                                    <Text style={{ color: "#fff" }} className='pair-h'>{item.pair}</Text>
                                                    <br />
                                                </div>
                                            </Col>

                                            {/* Right - Profit/Loss + Investment */}
                                            <Col span={5} style={{ textAlign: "right" }}>
                                                <Text
                                                    style={{
                                                        color: item.result >= 0 ? "#1BA136" : "#D74C39",
                                                        // fontWeight: 600,
                                                    }}
                                                    className='result-h'
                                                >
                                                    {item.result >= 0 ? `+$${item.result}` : `-$${Math.abs(item.result)}`}
                                                </Text>
                                                <br />
                                                <div className='display-4 gap-5 mt-5'>

                                                    <Text type="secondary" className='date-h '>${item.investment}</Text>{" "}
                                                    {item.result >= 0 ? (
                                                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M6.66667 0L0 10H14L6.66667 0Z" fill="#009C34" />
                                                        </svg>

                                                    ) : (
                                                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M6.66667 10L0 0H14L6.66667 10Z" fill="#EC5039" />
                                                        </svg>

                                                    )}
                                                </div>

                                            </Col>
                                        </Row>
                                    </List.Item>
                                )}
                            />
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default TradeHitorySide